import { FC } from 'react';
import { CommodityConditionFilters } from 'store/commodity-conditions-center/commodityCondition';
import { SFilterSelect, SFiltersRow } from 'views/templates/styles';
import FilterInput from './FilterInput';

type CodelistOption = { id: string | number; value: string };

interface Props {
    values: CommodityConditionFilters;
    countryOptions?: CodelistOption[];
    conditionCodeOptions?: CodelistOption[];
    isLoadingCodelists: boolean;
    onChange: (filter: keyof CommodityConditionFilters, value: string) => void;
}

const toSelectOptions = (options: CodelistOption[] = []) =>
    options.map(({ id, value }) => ({ value: id, label: `${id} - ${value}` }));

const Filters: FC<Props> = ({ values, countryOptions, conditionCodeOptions, isLoadingCodelists, onChange }) => (
    <SFiltersRow>
        <FilterInput
            placeholder="Commodity code"
            maxLength={8}
            value={values.commodityCode}
            onApply={(value) => onChange('commodityCode', value)}
        />
        <FilterInput
            placeholder="TARIC code"
            maxLength={2}
            value={values.taricCode}
            onApply={(value) => onChange('taricCode', value)}
        />
        <SFilterSelect
            showSearch
            allowClear
            placeholder="Country of origin"
            optionFilterProp="label"
            loading={isLoadingCodelists}
            options={toSelectOptions(countryOptions)}
            value={values.countryOrigin}
            onChange={(value) => onChange('countryOrigin', (value as string | undefined) ?? '')}
        />
        <SFilterSelect
            showSearch
            allowClear
            placeholder="Condition code"
            optionFilterProp="label"
            loading={isLoadingCodelists}
            options={toSelectOptions(conditionCodeOptions)}
            value={values.conditionCode}
            onChange={(value) => onChange('conditionCode', (value as string | undefined) ?? '')}
        />
    </SFiltersRow>
);

export default Filters;
